import ESignDocumentTemplate from './ESignDocumentTemplate';
import { termsLabelList } from '../../../consts/terms.js';
import ESignAgreementItem, { Checkbox, StyledLabel } from './AgreementItem';
import { useESign } from '../eSignApplicationContext';

const AgreementLayout = ({ isMobile, documentRef }) => {
  const { checkedList, toggleAllChecked } = useESign();

  return (
    <div ref={documentRef}>
      <ESignDocumentTemplate isMobile={isMobile}>
        <h1 style={{ fontSize: '28px', fontWeight: 600, color: '#000' }}>
          꼬르륵 서비스 이용 동의서
        </h1>
        <div style={{ height: 42 }} />
        {termsLabelList.map((_, index) => (
          <ESignAgreementItem key={index} isMobile={isMobile} index={index} />
        ))}
        <StyledLabel>
          본인은 본 계약 내용에 동의하며 전자서명으로 서면서명과 동일한 효력을 인정합니다.
        </StyledLabel>
        {!documentRef && (
          <Checkbox
            style={{ marginTop: 12, marginLeft: 'auto' }}
            isMobile={isMobile}
            label="전체 동의"
            checked={checkedList.every(Boolean)}
            onClick={toggleAllChecked}
          />
        )}
      </ESignDocumentTemplate>
    </div>
  );
};

export default AgreementLayout;
